"use strict";

import "whatwg-fetch";
import { API_URL } from "../config";
import { optionsGen } from "../helpers/api";

export function getPriorArtByQuery(q, after = '', before = '', dtype = 'priority', country = 'US', n = 10) {
  let url = `${API_URL}/pqai/search?q=${encodeURIComponent(q)}&n=${n}`;
  if (after) {
    url += `&after=${encodeURIComponent(after)}`;
  }
  if (before) {
    url += `&before=${encodeURIComponent(before)}`;
  }
  if (dtype) {
    url += `&dtype=${encodeURIComponent(dtype)}`;
  }
  if (country) {
    url += `&country=${encodeURIComponent(country)}`;
  }
  return fetch(url)
    .then(resp => resp.json())
    .then(json => json.results);
}

export function getPriorArtByPatent(pn, n = 10) {
  return fetch(`${API_URL}/pqai/patent?pn=${pn}&n=${n}`)
    .then(resp => resp.json())
    .then(json => json.results);
}

export function submitRating(rating, pn, claim) {
  const body = { rating: rating, pn: pn ? pn.replace(/-/g, "") : undefined, claim: parseInt(claim, 10) ? parseInt(claim, 10) : undefined };

  return fetch(`${API_URL}/pqai/rating`, optionsGen("POST", body, false)).then(resp => resp.json());
}
